import { track } from "@/features/analytics";

export const trackSettings = (
  event: string,
  properties: Record<string, unknown> = {},
) => track(event, { app: "settings", ...properties });
